import * as React from "react";
import { func } from "../../../utils";

import { ReactComponent as DefaultLogo } from "../../atoms/CardStatistik/assets/default-logo.svg";
import useWindowSize from "../../../hooks/useWindowSize";

export interface Props {
  cardWidth: string;
  schoolLogoUrl: string;
  schoolName: string;
  city: string;
  kvUrl: string;
  className?: string;
}

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;
const iconPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

const CardChampionSoc: React.FC<Props> = ({
  cardWidth,
  schoolLogoUrl,
  schoolName,
  city,
  kvUrl = "",
  className,
}) => {
  const { size } = useWindowSize();
  // @ts-ignore
  const isMobileView = (size?.width || 0) <= 830;

  const bannerBg = func.getStaticImg("illustration/champions-banner-swoosh.png");

  const logoPath = `${iconPath}${schoolLogoUrl}`;
  const kvPath = `${imgPath}${kvUrl}`;

  return (
    <div className={className} style={{ width: cardWidth }}>
      <div
        style={{ width: cardWidth }}
        className="rounded-[16px] h-[257px] overflow-hidden bg-slate-200"
      >
        <img
          style={{
            width: cardWidth,
            objectFit: "fill",
            height: 179,
            position: "relative",
            top: -4,
          }}
          className="rounded-t-[16px]"
          src={kvPath}
          alt="champion image"
        />
        <div
          style={{
            background: `url(${bannerBg})`,
            backgroundSize: "255px 102px",
          }}
          className="flex items-end h-[100px] w-[100%] relative top-[-22px] py-[16px] px-[12px] gap-x-[12px]"
        >
          {!schoolLogoUrl || schoolLogoUrl === "-" ? (
            <DefaultLogo width={49} height={49} />
          ) : (
            <img src={logoPath} alt="school logo" width={49} height={49} />
          )}

          <div className="justify-between w-[70%] whitespace-nowrap">
            <h1
              style={{ lineHeight: isMobileView ? "2rem" : "1.6rem" }}
              className="text-[16px] text-white text-ellipsis overflow-hidden"
            >
              {schoolName ?? "-"}
            </h1>
            <p className="text-[12px] text-white">{city ?? "-"}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardChampionSoc;
